import { Component } from '@verndale/core';
import { isFocusable } from '../helpers';
import { keyCode } from '../helpers/variables';

class VideoModal extends Component {
  setupDefaults() {
    this.provider = this.el.dataset.provider;
    this.videoId = this.el.dataset.videoId;
    this.title = this.el.dataset.title;
    this.ignoreUtilFocusChanges = false;
    this.lastFocus = null;
    this.identifier = this.el.dataset.identifier;

    // this.handleClickOutSide = this.handleClickOutSide.bind(this);
    this.handleVideoModalClose = this.handleVideoModalClose.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.dom = {
      body: document.querySelector('body')
    };

    this.checkQueryString();
  }

  addListeners() {
    this.el.addEventListener('click', this.handleVideoModalOpen.bind(this));
    this.el.addEventListener(
      'keypress',
      this.handleModalOpenKeyboard.bind(this)
    );
  }

  checkQueryString() {
    const urlParams = new URLSearchParams(window.location.search);
    const videoName = urlParams.get('videoName');
   
    if (videoName === this.identifier) {
      this.handleVideoModalOpen();
    }
  }

  removeListeners() {
    // this.dom.videoModal.removeEventListener('click', this.handleClickOutSide);
    this.dom.closeVideo.removeEventListener(
      'click',
      this.handleVideoModalClose
    );
    document.removeEventListener('keyup', this.handleEscape);
    document.removeEventListener('focus', this.handleFocus, true);
  }

  buildHtml() {
    let url = '';

    if (this.provider === 'vimeo') {
      url = `https://player.vimeo.com/video/${this.videoId}?autoplay=1`;
    }

    if (this.provider === 'wistia') {
      url = `//fast.wistia.net/embed/iframe/${this.videoId}?autoplay=1`;
    }

    this.dom.videoModal = document.createElement('div');
    this.dom.videoModal.setAttribute('role', 'dialog');
    this.dom.videoModal.setAttribute('aria-label', this.title);
    this.dom.videoModal.classList.add('video-modal');
    this.dom.videoModal.innerHTML = `
      <div class="video-modal__inner">
        <div class="video-modal__inner-height">
          <div class="video-modal__video-frame">
            <button class="video-modal__close" arialabel="Close Video Modal">
              <svg role="presentation">
                <use xlink:href="#close" />
              </svg>
            </button>
            <div class="video-modal__video-wrapper">
              <iframe src="${url}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="${this.title}"></iframe>
            </div>
          </div>
        </div>
      </div>
    `;

    this.dom.videoWrapper = this.dom.videoModal.querySelector(
      '.video-modal__video-frame'
    );

    this.dom.closeVideo = this.dom.videoModal.querySelector(
      '.video-modal__close'
    );
    // this.dom.videoModal.addEventListener('click', this.handleClickOutSide);
    this.dom.closeVideo.addEventListener('click', this.handleVideoModalClose);
    document.addEventListener('keyup', this.handleEscape);
    document.addEventListener('focus', this.handleFocus, true);
  }

  handleVideoModalOpen() {
    this.buildHtml();

    const { scrollY } = window;
    this.dom.body.style.position = 'fixed';
    this.dom.body.style.width = '100%';
    this.dom.body.style.top = `-${scrollY}px`;
    this.dom.body.classList.add('has-modal');
    this.dom.body.appendChild(this.dom.videoModal);
    this.focusFirstDescendant(this.dom.videoModal);
  }

  handleModalOpenKeyboard(e) {
    const key = e.which || e.keyCode;

    if (key === 13 || key === 32) {
      e.preventDefault();
      this.handleVideoModalOpen();
    }
  }

  handleClickOutSide(e) {
    if (
      e.target === this.dom.videoWrapper ||
      this.dom.videoWrapper.contains(e.target)
    ) {
      return;
    }
    this.handleVideoModalClose();
  }

  handleVideoModalClose() {
    this.removeListeners();

    const scrollY = document.body.style.top;
    this.dom.body.style.position = 'static';
    this.dom.body.style.width = '';
    this.dom.body.style.top = '';
    this.dom.body.classList.remove('has-modal');
    this.dom.body.removeChild(this.dom.videoModal);
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    this.el.focus();
  }

  handleEscape(e) {
    const key = e.which || e.keyCode;

    if (key === keyCode.ESC) {
      e.stopPropagation();
      this.handleVideoModalClose();
    }
  }

  handleFocus(e) {
    if (this.ignoreUtilFocusChanges) return;

    if (this.dom.videoModal.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.videoModal);

      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.videoModal);
      }
      this.lastFocus = document.activeElement;
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;
    try {
      element.focus();
    } catch {
      return;
    }
    this.ignoreUtilFocusChanges = false;
    return document.activeElement === element;
  }
}

export default VideoModal;
